import Vue from 'vue';
import gql from 'graphql-tag';

const SORTING_VALUES = [
    {
        value: 'sales',
        text: 'Sales',
    },
    {
        value: null,
        alias: 'relevance',
        text: 'Relevanz',
    },
    {
        value: 'priceAsc',
        text: 'Preis (aufsteigend)',
    },
    {
        value: 'priceDesc',
        text: 'Preis (absteigend)',
    },
];

export default {
    namespaced: true,
    state: {
        searchResultsLoaded: false,
        products: {},
        totalPages: 0,
        pageSize: 25,
        lastSearchParams: {},
        searchConfig: {},
        allowSwitchLayout: true,
        gridClasses: '',
        loading: false,
    },
    getters: {
        searchConfig: state => key => {
            let result = null;
            if (key) {
                if (state.searchConfig.hasOwnProperty(key)) {
                    result = state.searchConfig[key];
                }
            } else {
                result = state.searchConfig;
            }
            return result;
        },
        currentPage: state => state.lastSearchParams.page,
        sortingValues: () => SORTING_VALUES,
        defaultSorting: (state, getters) => {
            let defaultSortingTypeValue = getters.searchConfig('defaultSortingType');

            if (defaultSortingTypeValue) {
                let defaultSortingType = getters.sortingValues.filter(
                    v => v.value === defaultSortingTypeValue || v.alias === defaultSortingTypeValue
                );

                if (defaultSortingType.length) {
                    return defaultSortingType[0].value;
                }
            }

            return undefined;
        },
    },
    mutations: {
        SET_SEARCH_RESULTS_LOADED(state, flag) {
            if (state.searchResultsLoaded !== flag) {
                state.searchResultsLoaded = flag;
            }
        },
        SET_PRODUCTS(state, products) {
            if (products) {
                state.products = products;
            } else {
                state.products = {};
            }
        },
        SET_TOTAL_PAGES(state, foundItems) {
            state.totalPages = Math.ceil(foundItems / state.pageSize);
        },
        SET_LAST_SEARCH_PARAMS(state, lastSearchParams) {
            state.lastSearchParams = lastSearchParams;
        },
        SET_SEARCH_CONFIG(state, searchConfig) {
            state.searchConfig = searchConfig;
            if (searchConfig && searchConfig.searchProductsPerPage) {
                state.pageSize = searchConfig.searchProductsPerPage;
            }
        },
        SET_ALLOW_SWITCH_LAYOUT(state, value) {
            state.allowSwitchLayout = value;
        },
        SET_GRID_CLASSES(state, gridClasses) {
            state.gridClasses = gridClasses
        },
        setLoading(state, value) {
            state.loading = value;
        },
    },
    actions: {
        setSearchConfig({ commit }, config) {
            commit('SET_SEARCH_CONFIG', config);
        },
        loadResults({ state, commit, getters, rootState }, options) {
            commit('setLoading', true);
            if (options.attributes) {
                options.attributes = JSON.parse(JSON.stringify(options.attributes).replace(/::/g, '/'));
            }
            const requestParams = Object.assign({}, options);
            requestParams.limit = state.pageSize;
            requestParams.itemType = ['product', 'merchant', 'category'];

            if (!requestParams.sort && !state.lastSearchParams.sort) {
                requestParams.sort = getters.defaultSorting;
            }

            if (state.lastSearchParams !== requestParams) {
                return Vue.$graphql
                    .query({
                        query: gql`
                            query search($queryParams: JSON!, $priceParams: JSON!) {
                                search(queryParams: $queryParams, priceParams: $priceParams) {
                                    product
                                    merchant
                                    category
                                    layout
                                    template
                                }
                            }
                        `,
                        variables: {
                            queryParams: requestParams,
                            priceParams: [{
                                country: Vue.$country.getCountry(),
                                currency: Vue.$currency.getSelected(),
                            }],
                        }
                    })
                    .then(r => r.data.search)
                    .then(results => {
                        const lastSearchTotal = results.product ? results.product.total : 0;

                        (new Promise(resolve => results.resolveDeferredCommit = resolve)).then(() => {
                            commit('SET_PRODUCTS', results.product);
                            if (rootState.hasOwnProperty('SearchDropdown')) {
                                commit('SearchDropdown/SET_CATEGORIES_FOUND', results.category, { root: true });
                                commit('SearchDropdown/SET_MERCHANTS_FOUND', results.merchant, { root: true });
                                commit('SearchDropdown/SET_TOTAL_FOUND', results, {
                                    root: true
                                });
                            }
                            commit('SET_TOTAL_PAGES', lastSearchTotal);
                            commit('SET_LAST_SEARCH_PARAMS', requestParams);
                            commit('setLoading', false);
                        });

                        if (!options.deferredCommit) {
                            results.resolveDeferredCommit();
                        }

                        return results;
                    })
                    .catch(error => {
                        commit('API_DATA_FAILURE', error, { root: true });
                    });
            } else {
                return Promise.resolve({});
            }
        },
        loadCategory({commit}, category) {
            return Vue.$graphql
                .query({
                    query: gql`
                        query searchCategory($category: String!) {
                            searchCategory(category: $category) {
                                layout
                                template
                            }
                        }
                    `,
                    variables: {
                        category,
                    }
                })
                .then(r => r.data.searchCategory)
                .catch(error => {
                    return {};
                });
        },
    }
};
